module.exports = __webpack_public_path__ + "img/tax_ex2.49ac5c5d.png";